/* Vetro Power – service landing pages. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  if (window.__vpService) return;
  window.__vpService = true;

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = function (kind, key, val) {
    try {
      var s = window[kind];
      if (val === undefined) return s.getItem(key);
      s.setItem(key, val);
    } catch (e) { return null; }
  };

  /* ---------- Before / after slider ---------- */
  function initSlider(el) {
    var range = $('.vp-ba__range', el);
    var set = function () {
      el.style.setProperty('--pos', range.value + '%');
      range.setAttribute('aria-valuetext', range.value + '%');
    };
    range.addEventListener('input', set);
    set();
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var list = $('[role="tablist"]', root);
    var tabs = $$('[role="tab"]', list);
    var select = function (i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        panel.hidden = !on;
        if (on && !reduced) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
      list.setAttribute('data-active', i);
      if (focus) tabs[i].focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (n === undefined) return;
        e.preventDefault();
        select((n + tabs.length) % tabs.length, true);
      });
    });
  }

  /* ---------- Accordions (single-open FAQ, multi-open cover) ---------- */
  function initAccordion(root) {
    var single = root.getAttribute('data-vp-accordion') === 'single';
    var items = $$('.vp-acc__item', root);
    var setOpen = function (item, open) {
      item.classList.toggle('is-open', open);
      $('.vp-acc__btn', item).setAttribute('aria-expanded', open);
    };
    items.forEach(function (item) {
      $('.vp-acc__btn', item).addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        if (single && open) items.forEach(function (o) { if (o !== item) setOpen(o, false); });
        setOpen(item, open);
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.vp-reveal');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Popup ---------- */
  var popup, lastFocus;
  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePopup(); return; }
    if (e.key !== 'Tab' || popup.showModal) return;
    var f = $$('a[href], button:not([disabled])', popup).filter(function (x) { return x.offsetParent; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function openPopup(opts) {
    popup = popup || $('[data-vp-popup]');
    if (!popup) return;
    lastFocus = (opts && opts.returnTo) || document.activeElement;
    var photo = $('[data-vp-popup-photo]', popup);
    if (photo) photo.hidden = !(opts && opts.photoNote);
    if (popup.showModal) popup.showModal(); else popup.setAttribute('open', '');
    document.documentElement.classList.add('vp-modal-open');
    popup.addEventListener('keydown', trap);
    $('[data-vp-popup-card]', popup).focus();
  }
  function closePopup() {
    if (!popup || !popup.hasAttribute('open')) return;
    if (popup.close) popup.close(); else popup.removeAttribute('open');
    document.documentElement.classList.remove('vp-modal-open');
    popup.removeEventListener('keydown', trap);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initPopup() {
    popup = $('[data-vp-popup]');
    if (!popup) return;
    $$('[data-vp-popup-close]', popup).forEach(function (b) { b.addEventListener('click', closePopup); });
    popup.addEventListener('cancel', function (e) { e.preventDefault(); closePopup(); });
  }

  /* ---------- Scroll to form + plan pre-select ---------- */
  function goToForm(plan, label) {
    var card = document.getElementById('vp-callback-form');
    if (!card) return false;
    if (plan !== undefined) setPlan(plan, label);
    card.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    var name = $('[data-vp-name]', card);
    if (name) name.focus({ preventScroll: true });
    return true;
  }
  function setPlan(plan, label) {
    var input = $('[data-vp-plan-input]');
    var tag = $('[data-vp-plan-tag]');
    if (!input) return;
    input.value = plan || '';
    if (tag) {
      tag.hidden = !plan;
      $('[data-vp-plan-tag-text]', tag).textContent = plan ? (tag.getAttribute('data-prefix') || 'Plan:') + ' ' + (label || plan) : '';
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vp-callback], [data-vp-plan]');
    if (!a) return;
    var plan = a.hasAttribute('data-vp-plan') ? a.getAttribute('data-vp-plan') : undefined;
    if (goToForm(plan, a.getAttribute('data-vp-plan-label'))) e.preventDefault();
  });

  /* ---------- Callback form ---------- */
  var MSG = {
    name: 'Please enter your name.',
    phone: 'Please enter a valid 10-digit mobile number.',
    size: 'Please choose a photo under 5 MB.',
    type: 'Please choose an image file.'
  };
  var MAX = 5 * 1024 * 1024;

  function initForm(wrap) {
    var form = $('form', wrap);
    var name = $('[data-vp-name]', form);
    var phone = $('[data-vp-phone]', form);
    var photo = $('[data-vp-photo]', form);
    var submit = $('[data-vp-submit]', form);
    var banner = $('[data-vp-banner]', form);
    var submitLabel = $('.vp-btn__label', submit);
    var label = submitLabel.textContent;
    var service = wrap.getAttribute('data-service') || '';

    // Page URL + UTMs (persisted for the session)
    var params = new URLSearchParams(location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
      var v = params.get(k) || store('sessionStorage', 'vp_' + k);
      if (v) { utm[k] = v; store('sessionStorage', 'vp_' + k, v); }
    });
    $('[data-vp-page-url]', form).value = location.href.split('#')[0];
    $('[data-vp-utm]', form).value = Object.keys(utm).map(function (k) { return k + '=' + utm[k]; }).join('&');

    var clear = $('[data-vp-plan-clear]', form);
    if (clear) clear.addEventListener('click', function () { setPlan(''); name.focus(); });

    function fieldError(input, msg) {
      var field = input.closest('.vp-field');
      var err = document.getElementById(input.getAttribute('aria-describedby'));
      field.classList.toggle('has-error', !!msg);
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (err) err.textContent = msg || '';
      return !msg;
    }
    var checkName = function () { return fieldError(name, name.value.trim().length >= 2 ? '' : MSG.name); };
    var checkPhone = function () { return fieldError(phone, /^[6-9]\d{9}$/.test(phone.value) ? '' : MSG.phone); };

    name.addEventListener('blur', function () { if (name.value) checkName(); });
    phone.addEventListener('blur', function () { if (phone.value) checkPhone(); });
    phone.addEventListener('input', function () {
      var v = phone.value.replace(/\D/g, '').replace(/^(?:91|0)(?=\d{10}$)/, '').slice(0, 10);
      if (v !== phone.value) phone.value = v;
      if (phone.getAttribute('aria-invalid') === 'true') checkPhone();
    });
    name.addEventListener('input', function () { if (name.getAttribute('aria-invalid') === 'true') checkName(); });

    // Photo preview
    var upload = photo && photo.closest('[data-vp-upload]');
    function resetPhoto() {
      if (!photo) return;
      photo.value = '';
      upload.classList.remove('has-file');
      var tile = $('[data-vp-upload-tile]', upload);
      var img = $('img', tile);
      if (img) { URL.revokeObjectURL(img.src); img.remove(); }
      $$('svg', tile).forEach(function (s) { s.style.display = ''; });
      var t = $('[data-vp-upload-title]', upload), h = $('[data-vp-upload-hint]', upload);
      t.textContent = t.getAttribute('data-default');
      h.textContent = h.getAttribute('data-default');
      $('[data-vp-upload-add]', upload).hidden = false;
      $('[data-vp-upload-remove]', upload).hidden = true;
    }
    if (photo) {
      photo.addEventListener('change', function () {
        var f = photo.files && photo.files[0];
        fieldError(photo, '');
        if (!f) return resetPhoto();
        if (!/^image\//.test(f.type)) { resetPhoto(); return fieldError(photo, MSG.type); }
        if (f.size > MAX) { resetPhoto(); return fieldError(photo, MSG.size); }
        var tile = $('[data-vp-upload-tile]', upload);
        var img = $('img', tile) || document.createElement('img');
        img.alt = '';
        img.src = URL.createObjectURL(f);
        $$('svg', tile).forEach(function (s) { s.style.display = 'none'; });
        tile.appendChild(img);
        $('[data-vp-upload-title]', upload).textContent = f.name;
        $('[data-vp-upload-hint]', upload).textContent = Math.max(1, Math.round(f.size / 1024)) + ' KB';
        $('[data-vp-upload-add]', upload).hidden = true;
        $('[data-vp-upload-remove]', upload).hidden = false;
        upload.classList.add('has-file');
      });
      $('[data-vp-upload-remove]', upload).addEventListener('click', function () { resetPhoto(); photo.focus(); });
    }

    function busy(on) {
      submit.disabled = on;
      submitLabel.textContent = on ? 'Sending…' : label;
    }
    function success(plan, hadPhoto) {
      store('localStorage', 'vp_service_sent', String(Date.now()));
      if (window.dataLayer) window.dataLayer.push({ event: 'service_callback_submit', service: service, plan: plan || '' });
      // aria-disabled (not disabled) so focus can return to the button when the popup closes
      submit.disabled = false;
      submit.setAttribute('aria-disabled', 'true');
      submitLabel.textContent = label;
      openPopup({ returnTo: submit, photoNote: hadPhoto });
      setTimeout(function () { submit.removeAttribute('aria-disabled'); }, 3000);
    }
    function resetForm() {
      form.reset();
      resetPhoto();
      setPlan('');
      $('[data-vp-page-url]', form).value = location.href.split('#')[0];
    }

    // Capture phase on window so validation runs before Shopify's hCaptcha handler on the contact form.
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (submit.getAttribute('aria-disabled') === 'true') { e.preventDefault(); e.stopImmediatePropagation(); return; }
      banner.hidden = true;
      var ok = [checkName(), checkPhone()];
      var stop = function () { e.preventDefault(); e.stopImmediatePropagation(); };
      if (ok.indexOf(false) !== -1) {
        stop();
        (ok[0] ? phone : name).focus();
        return;
      }
      var plan = $('[data-vp-plan-input]', form).value;
      var hadPhoto = !!(photo && photo.files && photo.files.length);
      // Honeypot, or a successful send in the last 60 s: show success, send nothing.
      var last = +store('localStorage', 'vp_service_sent') || 0;
      if ($('[name="contact[website]"]', form).value || Date.now() - last < 60000) {
        stop();
        resetForm();
        return success(plan, false);
      }

      var endpoint = (wrap.getAttribute('data-endpoint') || '').trim();
      if (!endpoint) {
        // Email mode: let the native post (and Shopify's captcha) run; the popup opens when the
        // page comes back with ?contact_posted=true. Email can't carry the photo, so remember it.
        store('sessionStorage', 'vp_service_pending', JSON.stringify({ plan: plan, photo: hadPhoto }));
        busy(true);
        setTimeout(function () { busy(false); }, 10000); // visitor closed the captcha
        return;
      }

      stop();
      busy(true);
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
      var data = new FormData(form);
      var payload = new FormData();
      payload.append('name', name.value.trim());
      payload.append('phone', '+91' + phone.value);
      payload.append('plan', plan);
      payload.append('page_url', data.get('contact[Page URL]') || '');
      payload.append('service', service);
      payload.append('source', data.get('contact[Source]') || '');
      Object.keys(utm).forEach(function (k) { payload.append(k, utm[k]); });
      if (hadPhoto) payload.append('photo', photo.files[0]);
      fetch(endpoint, { method: 'POST', body: payload, signal: ctrl && ctrl.signal }).then(function (r) {
        clearTimeout(timer);
        if (!r.ok) throw new Error(r.status);
        resetForm();
        success(plan, false);
      }).catch(function () {
        clearTimeout(timer);
        busy(false);
        banner.hidden = false;
      });
    }, true);

    // Back from a native contact post (email mode)
    if ($('[data-vp-posted]', form)) {
      var pending = {};
      try { pending = JSON.parse(store('sessionStorage', 'vp_service_pending') || '{}'); } catch (err) {}
      store('sessionStorage', 'vp_service_pending', '');
      success(pending.plan, !!pending.photo);
    }
  }

  /* ---------- Header cart badge: hide at 0 (count itself stays owned by the theme) ---------- */
  function initCartCount() {
    $$('.vp-service-page cart-count').forEach(function (el) {
      var sync = function () { el.setAttribute('data-count', (el.textContent || '').trim()); };
      sync();
      new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    initCartCount();
    $$('[data-vp-ba]').forEach(initSlider);
    $$('[data-vp-tabs]').forEach(initTabs);
    $$('[data-vp-accordion]').forEach(initAccordion);
    initReveal();
    initPopup();
    $$('[data-vp-form-wrap]').forEach(initForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-bind when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target;
    $$('[data-vp-ba]', r).forEach(initSlider);
    $$('[data-vp-tabs]', r).forEach(initTabs);
    $$('[data-vp-accordion]', r).forEach(initAccordion);
    $$('.vp-reveal', r).forEach(function (el) { el.classList.add('is-visible'); });
    if ($('[data-vp-popup]', r)) { popup = null; initPopup(); }
    $$('[data-vp-form-wrap]', r).forEach(initForm);
  });
})();
